import { ComponentProps } from 'react';

import { Content, List, Root, Trigger } from '@radix-ui/react-tabs';

import { Billing, Capsule, Underscore } from './variants';

const variants = {
  underscore: Underscore,
  capsule: Capsule,
  billing: Billing,
};

interface VariantUnderscoreProps extends ComponentProps<typeof Underscore> {
  variant?: 'underscore';
}

interface VariantCapsuleProps extends ComponentProps<typeof Capsule> {
  variant: 'capsule';
}

interface VariantBillingProps extends ComponentProps<typeof Billing> {
  variant: 'billing';
}

type TabProps = VariantUnderscoreProps | VariantCapsuleProps | VariantBillingProps;

function Tab({ variant = 'underscore', ...props }: TabProps) {
  const TabVariant = variants[variant];

  return <TabVariant {...props} />;
}

Tab.Underscore = Underscore;
Tab.Capsule = Capsule;
Tab.Billing = Billing;
Tab.Root = Root;
Tab.List = List;
Tab.Content = Content;
Tab.Trigger = Trigger;

export { Tab };
